const button = document.querySelector('[data-video-url]')
if (button) {
  const videoUrl = button.getAttribute('data-video-url')
  createVideo(videoUrl)
}

if (isMobile()) {
  const mediaModal = document.querySelector('[data-media-modal]')
  if (mediaModal) mediaModal.remove()

  //Setting Controls to rest of videos
  document.querySelectorAll('[data-view-more-product-images] video').forEach((video) => {
    video.setAttribute('controls', 'controls')
  })
}

document.querySelectorAll('fieldset input.visually-hidden').forEach((button) => {
  button.nextElementSibling.addEventListener('click', (e) => {
    document.querySelector('[data-product-media-desktop] .grid.grid-cols-2 .hidden').classList.remove('hidden')
    if (!isMobile()) {
      document.querySelector('#video-pdp').closest('.col-span-2').classList.add('hidden')
    }

    const target = e.currentTarget
    createFeaturedImage(target, autoPlayInfo)
  })
})

async function createFeaturedImage(target, autoPlayInfo) {
  if (target.getAttribute('for') === 'kit2') {
    return
  }
  const image = `<img src="${autoPlayInfo.featuredMedia.src}" alt="iRESTORE Elite" loading="eager" class="absolute top-0 left-0 w-full h-full object-cover transition-all duration-500 ease-in-out" sizes="100vw" onload="this.classList.remove('opacity-0');this.classList.remove('scale-105');">
    <button onclick="showVideo()" class="ir-button absolute right-2 bottom-2 !bg-white !text-red border border-red font-bold !rounded-full !text-xs max-xl:!py-2.5 max-xl:!px-3.5 !min-w-max flex items-center gap-2 shadow-sm z-10 [--color-shadow:217,217,217]" data-video-url="cdn.shopify.com/videos/c/o/v/b891b04f6f7845e8bce0f990b464bac7.mp4" aria-label="Play video">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="text-red">
      <path d="M1 12C1 5.925 5.925 1 12 1C18.075 1 23 5.925 23 12C23 18.075 18.075 23 12 23C5.925 23 1 18.075 1 12Z" fill="currentColor"></path>
      <path d="M9.5 15.584V8.41604C9.50015 8.32635 9.52442 8.23836 9.57026 8.16128C9.61611 8.0842 9.68184 8.02087 9.76057 7.97792C9.83931 7.93498 9.92814 7.914 10.0178 7.91719C10.1074 7.92037 10.1945 7.94761 10.27 7.99604L15.846 11.579C15.9166 11.6243 15.9747 11.6865 16.0149 11.7601C16.0552 11.8337 16.0763 11.9162 16.0763 12C16.0763 12.0839 16.0552 12.1664 16.0149 12.24C15.9747 12.3135 15.9166 12.3758 15.846 12.421L10.27 16.005C10.1945 16.0535 10.1074 16.0807 10.0178 16.0839C9.92814 16.0871 9.83931 16.0661 9.76057 16.0232C9.68184 15.9802 9.61611 15.9169 9.57026 15.8398C9.52442 15.7627 9.50015 15.6747 9.5 15.585V15.584Z" fill="white"></path>
    </svg> SEE IT IN ACTION </button>
  <div class="absolute top-2 left-2 xs:top-5 xs:left-5 rounded-full bg-red text-white text-xs font-bold uppercase px-2 py-1"> New </div>
    `

  if (isMobile()) {
    const mobileWrapper = await waitForElm('#product-media-splide-slide01')
    mobileWrapper.innerHTML = image

    mobileWrapper.classList.remove('pt-[76%]')
  } else {
    const firstImage = document.querySelector('[data-product-media-desktop] .grid.grid-cols-2 .col-span-2')
    firstImage.classList.remove('hidden')

    const wrapper = await waitForElm('#video-pdp')
    wrapper.parentNode.classList.add('hidden')
  }
}

function isMobile() {
  return window.matchMedia('(max-width: 600px)').matches
}

async function createVideo(videoUrl) {
  // Options for the Intersection Observer
  const optionsIntersection = {
    root: null, // Use the viewport as the root
    rootMargin: '0px', // No margin around the root
    threshold: 0.5, // Trigger when 50% of the video is visible
  }

  const firstImage = document.querySelector('[data-product-media-desktop] .grid.grid-cols-2 .col-span-2')
  firstImage.classList.add('hidden')

  const wrapper = `
    <div class="col-span-2 relative pt-[100%] rounded-xl overflow-hidden border border-light-silver px-2">
        <video autoplay="autoplay" loop="loop" controls="true" muted playsinline preload="auto" class="absolute top-0 left-0 w-full h-full" id="video-pdp">
            <source src="https://${videoUrl}" type="video/mp4">
        </video>
    </div>`

  if (isMobile()) {
    const mobileVideoHTML = `<video autoplay="autoplay" loop="loop" preload="auto" controls="true" muted playsinline class="absolute top-0 left-0 w-full h-full" id="video-pdp-mobile">
            <source src="https://${videoUrl}" type="video/mp4">
        </video>`

    const mobileWrapper = await waitForElm('#product-media-splide-slide01')
    mobileWrapper.innerHTML = mobileVideoHTML

    const mobileVideo = document.querySelector('#video-pdp-mobile')
    mobileVideo.load()
    mobileVideo.play()

    // Callback function for the Intersection Observer
    const handleIntersectionMobile = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Video is in the viewport
          mobileVideo.play()
        } else {
          // Video is out of the viewport
          mobileVideo.pause()
        }
      })
    }
    const observerMobile = new IntersectionObserver(handleIntersectionMobile, optionsIntersection)

    observerMobile.observe(mobileVideo)
  } else {
    const target = document.querySelector('[data-product-media-desktop] .grid.grid-cols-2')
    target.insertAdjacentHTML('afterbegin', wrapper)

    const video = document.querySelector('#video-pdp')
    video.load()
    // Callback function for the Intersection Observer
    const handleIntersection = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Video is in the viewport
          video.play()
          // GA tracking for video play
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'videoPlay',
            videoName:
              video.getAttribute('alt') ||
              [...video.querySelectorAll('source')]?.at(-1)?.getAttribute('src') ||
              'Unnamed video',
          })
        } else {
          // Video is out of the viewport
          video.pause()
        }
      })
    }

    // Create an Intersection Observer
    const observer = new IntersectionObserver(handleIntersection, optionsIntersection)

    // Start observing the video
    observer.observe(video)
  }
}

function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector))
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        observer.disconnect()
        resolve(document.querySelector(selector))
      }
    })

    // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })
  })
}

function showVideo() {
  const button = document.querySelector('[data-video-url]')
  const videoUrl = button.getAttribute('data-video-url')
  createVideo(videoUrl)
}
